// Member
export const  ORG_MEMBER_LIST_TABLE = [
    ["부서", "orgNm"],
    ["직급", "position"],
    ["권한", "memberRole"],
    ["이름", "memberNm"],
    ["연락처", "telNum"],
    ["주민번호", "ssno"],
    ["이메일", "email"],
    ["대출모집인번호", "loanBrokerNo"],
    ["사번(ID)", "id"],
    ["은행명", "bankNm"],
    ["계좌번호", "bankAccount"],
    ["본부장", "headMgrYn"],
    ["관리팀장", "managementMgrYn"],
    ["영업팀장", "salesMgrYn"],
    ["비밀번호 초기화", "reset"]
];

export const  USER_UPLOAD_TABLE = [
    ["부서명", "orgNm"],
    ["직급", "position"],
    ["권한", "memberRole"],
    ["이름", "memberNm"],
    ["연락처", "telNum"],
    ["주민번호", "ssno"],
    ["이메일", "email"],
    ["대출모집인번호", "loanBrokerNo"],
    ["은행", "bankNm"],
    ["계좌번호", "bankAccount"],
    ["입사일", "hireDate"],
    ["직무코드", "jobCode"],
    ["사번", "id"],
    ["본부장", "headMgrYn"],
    ["관리팀장", "managementMgrYn"],
    ["영업팀장", "salesMgrYn"]
];

export const  DELETE_ORG_LIST_TABLE = [
    ["부서명", "orgNm"],
    ["부서원수", "memberCnt"],
    ["생성일", "stDt"],
    ["삭제일", "edDt"],
    ["삭제관리자", "updateNm"],
    ["복구", "restore"]
];
export const  DELETE_MEMBER_LIST_TABLE = [
    ["부서명", "orgNm"],
    ["회원명", "memberNm"],
    ["생성일", "hireDate"],
    ["삭제일", "delDate"],
    ["삭제관리자", "updateNm"],
    ["복구", "restore"]
];

// Board
export const  BOARD_MANAGE_TABLE = [
    ["NO.", "categoryId"],
    ["게시판명", "categoryNm"],
    ["게시글수", "cnt"],
    ["상태", "useYn"],
    ["작업", "modify"]
];

// Loan
export const LOAN_PERFORMANCE_UPLOAD_TABLE = [
    ["업로드 날짜", "createDate"],
    ["파일명", "fileNm"],
    ["등록자", "createNm"],
    ["파일건수", "rowCount"],
    ["적용상태", "state"],
    ["에러내용", "errorMsg"],
    ["파일삭제", "delete"],
    ["사용여부", "delYn"]
];

export const LOAN_MONTHLY_STATICS_SUMMARY_TABLE = [
    ["업로드 날짜", ""],
    ["파일명", "fileNm"],
    ["등록자", ""]
];

export const LOAN_MONTHLY_STATICS_SUBJECTS_TABLE = [
    ["업로드 날짜", ""],
    ["파일명", "fileNm"],
    ["등록자", ""]
];

export const LOAN_MONTHLY_STATICS_TYPES_TABLE = [
    ["업로드 날짜", ""],
    ["파일명", "fileNm"],
    ["등록자", ""]
];

// 대출실적 - 전체실적
export const LOAN_PERFORMANCE_TOTAL_TEAM_TABLE = [
    ["팀", "nm"],
    ["건수", "cnt"],
    ["건수(%)", "cntRate"],
    ["대출금액", "loanAmount"],
    ["대출금액(%)", "loanAmountRate"],
    ["수수료(-VAT)", "feeTotal"],
    ["수수료금액(%)", "feeTotalRate"]
];

export const LOAN_PERFORMANCE_TOTAL_PRODUCT_TABLE = [
    ["대출과목(세부)", "nm"],
    ["건수", "cnt"],
    ["건수(%)", "cntRate"],
    ["대출금액", "loanAmount"],
    ["대출금액(%)", "loanAmountRate"],
    ["수수료(-VAT)", "feeTotal"],
    ["수수료금액(%)", "feeTotalRate"]
];

export const LOAN_PERFORMANCE_TOTAL_MANAGER_TABLE = [
    ["성명", "nm"],
    ["건수", "cnt"],
    ["대출금액", "loanAmount"]
];

export const LOAN_PERFORMANCE_TOTAL_LOAN_TYPE_TABLE = [
    ["대출과목(세부)", "nm"],
    ["건수", "cnt"],
    ["건수(%)", "cntRate"],
    ["대출금액", "loanAmount"],
    ["대출금액(%)", "loanAmountRate"],
    ["수수료(-VAT)", "feeTotal"],
    ["수수료금액(%)", "feeTotalRate"]
];

// 대출실적 - 팀실적
export const LOAN_PERFORMANCE_TEAM_SUM_TABLE = [
    ["팀", "teamNm"],
    ["건수", "cnt"],
    ["대출금액", "loanAmount"],
    ["수수료(-VAT)", "feeTotal"]
];

export const LOAN_PERFORMANCE_TEAM_MEMBER_TABLE = [
    ["순위", "rank"],
    ["성명", "agentNm"],
    ["팀", "teamNm"],
    ["건수", "cnt"],
    ["대출금액", "loanAmount"],
    ["수수료", "feeTotal"]
];

export const LOAN_PERFORMANCE_TEAM_PRODUCT_TABLE = [
    ["구분", "loanSubjectGroupNm"],
    ["건수", "cnt"],
    ["대출금액", "loanAmount"],
    ["수수료(-VAT)", "feeTotal"]
];

// 대출실적 - 개인실적
export const LOAN_PERFORMANCE_MINE_SUM_TABLE = [
    ["팀", "teamNm"],
    ["건수", "cnt"],
    ["대출금액", "loanAmount"],
    ["수수료(-VAT)", "feeTotal"]
];

export const LOAN_PERFORMANCE_MINE_DETAIL_TABLE = [
    ["모집인번호", "agentNo"],
    ["팀", "teamNm"],
    ["모집인성명", "agentNm"],
    ["관리팀장", "managerNm"],
    ["영업팀장", "salesMgrNm"],
    ["실행일자", "executionDate"],
    ["만기일자", "maturityDate"],
    ["취급점", "branchCode"],
    ["취급점명", "branchName"],
    ["단체혐의번호", "groupCode"],
    ["집단대", "loanSubjectGroup"],
    ["대출과목", "loanSubject"],
    ["대출과목 (세부-1)", "loanSubjectDetail"],
    ["담보종류", "collateralType"],
    ["중개업소경유", "viaAgency"],
    ["대출금액", "loanAmount"],
    ["기보유대출금액", "prevLoanAmount"],
    ["상환예정금액", "repayAmount"],
    ["수수료대상금액", "feeBaseAmount"],
    ["수수료총액", "feeTotal"],
    ["집단대서류접수경로", "submissionPath"]
];


// Certificate
export const  CERTIFICATE_SIGNUP_ADMIN_TABLE = [
    ["신청자", "reqNm"],
    ["주민등록번호", "ssno"],
    ["신청날짜", "createDate"],
    ["발급날짜", "updateDate"],
    ["증명서종류", "certificateType"],
    ["명함상세", "cardDetail"],
    ["상태", "state"],
    ["메모", "reqNote"],
    ["거절사유", "resNote"],
    ["미리보기/다운로드", "etc"],
    ["발급", "issue"]
];
export const  CERTIFICATE_SIGNUP_USER_TABLE = [
    ["신청날짜", "createDate"],
    ["발급날짜", "updateDate"],
    ["증명서종류", "certificateType"],
    ["명함상세", "cardDetail"],
    ["상태", "state"],
    ["거절사유", "resNote"],
    ["미리보기/다운로드", "etc"]
];

// Lecture
export const  LECTURE_CATEGORY_TABLE = [
    ["카테고리ID", "categoryId"],
    ["카테고리명", "categoryNm"],
    ["동영상수", "cnt"],
    ["이용권한", "useRole"],
    ["노출여부", "useYn"],
    ["수정", "modify"]
];

export const  LECTURE_DASHBOARD_TABLE = [
    ["부서", "orgNm"],
    ["직급", "position"],
    ["이름", "memberNm"],
    ["연락처", "telNum"],
    ["이메일", "email"],
    ["주민번호", "ssno"]
];


// Payment
export const  PAYMENT_MANAGE_TABLE = [
    ["기준년월", "baseYm"],
    ["검증값", "checkNm"],
    ["조직명", "orgNm"],
    ["직책구분", "positionType"],
    ["모집인번호", "loanBrokerNo"],
    ["회원명", "memberNm"],
    ["총지급액", "sumPaymentAmount"],
    ["공제급액합계", "totalDeductionAmount"],
    ["차인지급액", "netPaymentAmount"]
];

// Etc
export const  SERVICE_LOG_TABLE = [
    ["조직명", "orgNm"],
    ["사용자명", "memberNm"],
    ["아이디(사번)", "id"],
    ["IP", "ip"],
    ["구분", "apiNm"],
    ["상태", "state"],
    ["처리일", "createDate"]
];